import List from "./List";
import Edit from "./Edit";
import Form from "./Form";
import New from "./New";

export default {
  List,
  Edit,
  Form,
  New
};
